import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.75 8.75V8a.75.75 0 0 0-.733.907zm14.5 0 .733.157A.75.75 0 0 0 19.25 8zM6.661 17.67l.734-.158zm10.678 0-.734-.158zM4.75 9.5h14.5V8H4.75zm13.767-.907-1.912 8.919 1.467.314 1.911-8.919zM15.383 18.5H8.617V20h6.766zm-7.988-.988-1.912-8.92-1.466.315 1.91 8.92zm1.222.988a1.25 1.25 0 0 1-1.222-.988l-1.467.314A2.75 2.75 0 0 0 8.617 20zm7.988-.988a1.25 1.25 0 0 1-1.222.988V20a2.75 2.75 0 0 0 2.69-2.174z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M7.288 8.263a.75.75 0 1 0 1.424.474zm2.674-3.276a.75.75 0 1 0-1.424-.474zm-1.25 3.75 1.25-3.75-1.424-.474-1.25 3.75zM15.289 8.737a.75.75 0 1 0 1.423-.474zm.172-4.224a.75.75 0 1 0-1.422.474zm1.25 3.75-1.25-3.75-1.422.474 1.25 3.75z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }